module.exports = __webpack_public_path__ + "img/listing.9179d21b.png";